import { makeVar } from '@apollo/client';

import { getOrdersStatusFromStorage } from '../../utils/order/get-orders-status-from-storage';

export const setIsLocatorIconsCampaign = makeVar<boolean>(false);
export const setIsCaptcha = makeVar<boolean>(false);
export const setC2CMode = makeVar<string | null>(getOrdersStatusFromStorage());
export const setMyAcuvueId = makeVar<string>('');
export const setIsVideoCall = makeVar<boolean>(false);
export const setMyopiaControl = makeVar<boolean>(false);
